// AnimatedStep.tsx
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useRef, useState } from "react";

const variants = {
  enter: (direction: number) => ({
    opacity: 0,
    y: direction > 0 ? -20 : 20,
  }),
  center: {
    opacity: 1,
    y: 0,
  },
  exit: (direction: number) => ({
    opacity: 0,
    y: direction > 0 ? 20 : -20,
  }),
};

export function AnimatedSteps({
  step,
  direction,
  children,
}: {
  step: number;
  direction: number;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | "auto">("auto");

  useEffect(() => {
    if (!ref.current) return;
    const ro = new ResizeObserver(([entry]) => {
      setHeight(entry.contentRect.height);
    });
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);

  return (
    <motion.div
      animate={{ height }}
      transition={{ duration: 0.25, ease: [0.20, 1, 0.36, 1] }}
      style={{ overflowY: "clip", overflowX: "visible" }}
    >
      <div ref={ref} className="-mx-1">
        <AnimatePresence mode="wait" initial={false} custom={direction}>
          <motion.div
            className="pb-1.5"
            key={step}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.1, ease: "easeOut" }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  );
}